export const KEY_TAB = 'Tab' as const
